module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/typography/list-style-round-outline/list-style-round-outline.component.scss
// module id = ./src/app/features/typography/list-style-round-outline/list-style-round-outline.component.scss
// module chunks = main